import { t as e } from "./MapReader-BeVNpm6y.js";
import { t } from "./SkeletonMapReader-ZPwsqemZ.js";
import { convertLabel as n, convertRoom as r, readMapFromBuffer as i, readerExport as a, streamRooms as o } from "mudlet-map-binary-reader";
//#region src/binary/convert.ts
function s(e, t, n = "") {
	let r = {};
	for (let t in e.customLines) {
		let n = e.customLines[t];
		r[t] = {
			points: n.points,
			attributes: {
				color: {
					alpha: 255,
					r: n.attributes.color.r,
					g: n.attributes.color.g,
					b: n.attributes.color.b
				},
				style: n.attributes.style,
				arrow: n.attributes.arrow
			}
		};
	}
	return {
		id: e.id,
		area: e.area,
		x: e.x,
		y: e.y,
		z: e.z,
		areaId: t,
		weight: e.weight,
		roomChar: e.roomChar ?? "",
		name: e.name,
		userData: e.userData,
		customLines: r,
		stubs: e.stubs,
		hash: e.hash ?? n,
		env: e.env ?? 0,
		exits: e.exits,
		doors: e.doors,
		specialExits: e.specialExits,
		exitLocks: e.exitLocks,
		exitWeights: e.exitWeights,
		mSpecialExitLocks: e.mSpecialExitLocks
	};
}
function c(e, t) {
	return {
		labelId: e.labelId ?? e.id,
		areaId: e.areaId ?? t,
		pixMap: e.pixMap || void 0,
		X: e.X,
		Y: e.Y,
		Z: e.Z,
		Width: e.Width,
		Height: e.Height,
		Text: e.Text,
		FgColor: e.FgColor,
		BgColor: e.BgColor,
		noScaling: e.noScaling,
		showOnTop: e.showOnTop
	};
}
var l = (e) => !!e && Object.keys(e).length > 0;
function u(e) {
	return !!e.symbol || l(e.customLines) || l(e.mSpecialExits) || (e.stubs?.length ?? 0) > 0 || l(e.doors) || (e.exitLocks?.length ?? 0) > 0 || e.weight !== 1 || l(e.exitWeights);
}
//#endregion
//#region src/binary/BinaryMapReader.ts
var d = class t {
	constructor(t) {
		let { mapData: n, colors: r } = a(t);
		this.reader = new e(n.map((e) => ({
			areaName: e.areaName,
			areaId: e.areaId,
			rooms: e.rooms.map((t) => s(t, e.areaId, t.hash)),
			labels: e.labels.map((t) => c(t, parseInt(e.areaId)))
		})), r);
	}
	static fromBuffer(e) {
		return new t(i(e));
	}
	getArea(e) {
		return this.reader.getArea(e);
	}
	getAreas() {
		return this.reader.getAreas();
	}
	getRooms() {
		return this.reader.getRooms();
	}
	getRoom(e) {
		return this.reader.getRoom(e);
	}
	getColorValue(e) {
		return this.reader.getColorValue(e);
	}
	getSymbolColor(e, t) {
		return this.reader.getSymbolColor(e, t);
	}
}, f = [
	"north",
	"northeast",
	"east",
	"southeast",
	"south",
	"southwest",
	"west",
	"northwest",
	"up",
	"down",
	"in",
	"out"
], p = class extends Error {};
function m(e) {
	let t;
	try {
		o(e, () => {
			throw new p();
		}, (e) => {
			let n = 0;
			for (let t in e.areas ?? {}) n += e.areas[t].rooms.length;
			throw t = {
				header: e,
				total: n
			}, new p();
		});
	} catch (e) {
		if (!(e instanceof p)) throw e;
	}
	if (!t) throw Error("failed to decode map header");
	return t;
}
function h(e) {
	let t = {};
	for (let n in e.areas ?? {}) t[n] = e.areas[n].gridMode;
	return t;
}
var g = (e) => !!e && Object.keys(e).length > 0;
function _(e) {
	let { mapData: t, colors: n } = a(i(e));
	return {
		kind: "plain",
		map: t.map((e) => ({
			areaName: e.areaName,
			areaId: e.areaId,
			rooms: e.rooms.map((t) => s(t, e.areaId, t.hash)),
			labels: e.labels.map((t) => c(t, parseInt(e.areaId)))
		})),
		envs: n
	};
}
function v(e, t, i, a, l = u) {
	let d = new Int32Array(i), p = new Int32Array(i), m = new Int32Array(i), _ = new Int32Array(i), v = new Int32Array(i), y = new Int32Array(i), b = new Int32Array(i * 12).fill(-1), x = Array(i), S = [], C = [], w = {};
	for (let e in t.mpRoomDbHashToRoomId) w[t.mpRoomDbHashToRoomId[e]] = e;
	let T = () => typeof performance < "u" ? performance.now() : Date.now(), E = T(), D = 0;
	o(e, (e, t) => {
		d[D] = t.x, p[D] = t.y, m[D] = t.z, _[D] = t.area, v[D] = t.environment, y[D] = e;
		let n = D * 12;
		for (let e = 0; e < 12; e++) b[n + e] = t[f[e]];
		if (x[D] = t.name ?? "", g(t.userData) && S.push({
			id: e,
			data: t.userData
		}), l(t)) {
			let n = r(e, t, w[e]);
			C.push(s(n, String(t.area), w[e]));
		}
		if (D++, a) {
			let e = T();
			e - E >= 80 && (E = e, a(D, i));
		}
	}), a?.(D, i);
	let O = {};
	for (let e in t.mCustomEnvColors ?? {}) {
		let n = t.mCustomEnvColors[e];
		O[e] = {
			r: n.r,
			g: n.g,
			b: n.b
		};
	}
	let k = [];
	for (let e in t.labels ?? {}) {
		let r = Number(e);
		for (let e of t.labels[r]) k.push(c(n(e), r));
	}
	return {
		kind: "skeleton",
		skeleton: {
			count: D,
			x: d,
			y: p,
			z: m,
			area: _,
			env: v,
			id: y,
			exits: b,
			areaNames: t.areaNames ?? {},
			areaGridMode: h(t),
			customEnvColors: O,
			names: x,
			userData: S,
			detailRooms: C,
			labels: k,
			hashToId: t.mpRoomDbHashToRoomId ?? {}
		}
	};
}
function y(e, t = {}) {
	let { mode: n = "auto", threshold: r = 5e4, onProgress: i, isDetailRoom: a } = t, { header: o, total: s } = m(e);
	return (n === "auto" ? s > r ? "streaming" : "plain" : n) === "plain" ? _(e) : v(e, o, s, i, a);
}
function b(n) {
	return n.kind === "plain" ? new e(n.map, n.envs) : new t(n.skeleton);
}
function x(e, t) {
	return b(y(e, t));
}
//#endregion
export { d as BinaryMapReader, x as loadMudletMap, y as parseMudletMap, b as readerFromLoadedMap };

//# sourceMappingURL=binary.mjs.map